import type { PlatformType } from '@/types'

import type { HbBidderConfig } from '../types'

const getTappxKey = (platform: PlatformType) =>
    platform === 'desktop' ? 'pub-93521-desktop-7229' : 'pub-93520-mweb-7179'

export const TAPPX_BANNER: HbBidderConfig = {
    bidder: 'tappx',
    params: ({ platform }) => ({
        tappxkey: getTappxKey(platform),
        endpoint: 'zz43701pg',
        host: 'zz43701pg.pub.tappx.com/rtb/',
    }),
}

export const TAPPX_VIDEO: HbBidderConfig = {
    bidder: 'tappx',
    params: ({ platform }) => ({
        tappxkey: getTappxKey(platform),
        endpoint: 'vz43701pg',
        host: 'vz43701pg.pub.tappx.com/rtb/',
    }),
}
